import { render, staticRenderFns } from "./ritm-select.vue?vue&type=template&id=2596301c"
import script from "./ritm-select.vue?vue&type=script&lang=js"
export * from "./ritm-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports